import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

/**
 *
 */
export class HorizontalChipFilterController extends Controller<HTMLFormElement> {
    static targets = ['horizontalChipFilterInput']

    static register(application: Application) {
        application.register('horizontal-chip-filter', this);
    }

    connect() {
        const filterInputs = this.horizontalChipFilterInputTargets;

        this.element.addEventListener('reset', evt => {
            evt.preventDefault();

            filterInputs.forEach(filterInput => filterInput.checked = false);
            this.element.requestSubmit();
        })
    }
}

export default HorizontalChipFilterController;